<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div class="ranking_title">از پومودورو حرفه‌ای‌تر استفاده کنید!</div>
    <div class="ranking_excerpt">
      با خرید نسخه حرفه‌ای پومودورو، از امکانات بیشتری بهره‌مند شوید و حرفه‌ای‌تر از پومودورو استفاده کنید.
    </div>
    <div id="pricing_row">
      <div class="pricing_pro_box">
        <div class="pricing_head">
          <div class="pricing_title">نسخه حرفه‌ای</div>
          <div class="pricing_excerpt">از پومودورو حرفه‌ای‌تر استفاده کن!</div>
        </div>
        <div class="pricing_body">
          <div class="ability">
            <ul>
              <li>تمامی امکانات نسخه رایگان + امکانات زیر:</li>
              <li>تنظیمات و شخصی‌سازی زمان‌سنج</li>
              <li>نمودار مقایسه روزانه عملکرد</li>
              <li>چارت دسته بندی فعالیت‌ها بر اساس زمان</li>
              <li>نمودار مقایسه ماهانه عملکرد</li>
              <li>قابلیت تعریف یادآوری‌های پیامکی</li>
              <li>فعالسازی حالت شب (Dark Mode)</li>
            </ul>
          </div>
          <div class="choose_time_box">
            <div class="discount_element">
              <img src="/assets/image/discount-elemet.svg">
            </div>
            <div class="discount_alert">۵۰٪ تخفیف بیشتر</div>
            <div class="choose_time_item" (click)="switchToYearlyMode()" [ngClass]="{'active': paymentMode === 'سالانه'}">سالانه</div>
            <div class="choose_time_item" (click)="switchToMonthlyMode()" [ngClass]="{'active': paymentMode === 'ماهانه'}">ماهانه</div>
<!--            <div class="choose_time_item" *ngFor="let plan of plans" (click)="checkPlanTab(plan)"-->
<!--                 [ngClass]="{'active': activeMode === plan.id}">{{plan.title}}</div>-->
            <div class="clearfix"></div>
          </div>
          <div class="price_value"><span>{{monthlyPay}}</span> هزار تومان / ماهانه</div>
          <div class="pricing_payment_button" (click)="pay()">پرداخت</div>
        </div>
      </div>
      <div class="pricing_free_box">
        <div class="pricing_head">
          <div class="pricing_title">نسخه رایگان</div>
          <div class="pricing_excerpt">تا همیشه رایگان خواهد ماند :)</div>
        </div>
        <div class="pricing_body">
          <div class="ability">
            <ul>
              <li>زمان‌سنج حرفه‌ای پومودورو</li>
              <li>تعریف دسته‌بندی</li>
              <li>تعریف لیست کارهای برای انجام</li>
              <li>مدیریت زمان تمرکز و استراحت</li>
              <li>گزارش کارهای انجام شده</li>
              <li>همگام‌سازی در همه دستگاه‌ها</li>
              <li>اعلام زمان‌های اتمام کارها و استراحت‌ها</li>
              <li>دریافت اعلان (Notifications)</li>
              <li>دریافت صدای هشدار (Alarm Sound)</li>
              <li>انتخاب نوع صدای هشدار</li>
              <li>آرشیو کارهای انجام شده با فیلتر دسته‌بندی</li>
              <li>آرشیو کارهای انجام شده با فیلتر زمان</li>
              <li>قابلیت شرکت در رتبه بندی عمومی</li>
              <li>ترجمه به ۷ زبان زنده دنیا</li>
            </ul>
          </div>
          <div class="pricing_signin">
<!--            <a [routerLink]="['/register']">رایگان شروع کن!</a>-->
            <a (click)="startFree()">رایگان شروع کن!</a>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="payment_box_cover" *ngIf="popUpMode">
      <ng-container *ngIf="userIsLoggedIn">
        <div>
          <div class="payment_box">
            <div class="row_payment_box">
              <div class="title_total_price">مبلغ کل</div>
              <div class="label_total_price">{{paymentMode}}</div>
              <div class="value_total_price"><span>{{totalPaymentWithoutDiscount}}</span> هزار تومان</div>
              <div class="clearfix"></div>
            </div>
            <div class="row_discount_code_input">
              <div class="discount_code_input">
                <input type="text" placeholder="اگر کد تخفیف دارید، وارد کنید :)" class="success_discount"
                       [ngClass]="{'success_discount' : discountAlert === 'success', 'wrong_discount': discountAlert === 'fail'}"
                       [(ngModel)]="couponCode" (keyup.enter)="verifyDiscountCode()" (change)="verifyDiscountCode()">
                <div *ngIf="discountAlert === 'fail'" class="discount_code_wrong_alert">{{errorMessage}}</div>
                <div *ngIf="discountAlert === 'success'" class="discount_code_success_alert">{{discountMessage}}</div>
                <button (click)="verifyDiscountCode()">ثبت</button>
              </div>
            </div>
            <div class="row_box_payment_final">
              <div class="title_payment_final">مبلغ قابل پرداخت</div>
              <div class="value_total_price"><span>{{totalPaymentWithDiscount}}</span> هزار تومان</div>
              <div class="clearfix"></div>
            </div>
            <div class="row_payment_buttons">
              <div class="col_payment_button">
                <div class="payment_button_pay" (click)="buyPlan()">پرداخت</div>
              </div>
              <div class="col_payment_button">
                <div class="payment_button_cancel" (click)="cancelPay()">انصراف</div>
              </div>
              <div class="clearfix"></div>
            </div>
          </div><!-- .payment_box -->
        </div>
      </ng-container>
      <ng-container *ngIf="!userIsLoggedIn">
        <div>
          <div class="payment_box login_req">
            <div class="dismiss-pop-up" (click)="cancelPay()">&times;</div>
            لطفا ابتدا <a class="login_link" (click)="navigateToLoginPage()">وارد حساب کاربری</a> خود شوید.
          </div><!-- .payment_box -->
        </div>
      </ng-container>
    </div><!-- .payment_box_cover -->
  </div><!-- .container -->
</div><!-- #main_app -->
<app-footer></app-footer>
